import React, { useEffect, useRef } from "react";
import { Container, Header } from "./Styled";
import { Button } from "antd";
import { useSelector } from 'react-redux'
import {RootState} from '../../../../model/rootReducer/'
import Item from "./Item/Item"
import MenuList, { Item as MenuItem } from "../../../system/menuList";
import { Flow } from "../../../../model/workflowEditor/flow/types";
import _ from "lodash";
import { usePrevious } from "../../../../helpers/hooks";

type FlowListProps = {
  onSelect: (intent?: Flow  | null) => void
  selectedFlowId: string | undefined | null;
};

const FlowList: React.FunctionComponent<FlowListProps> = props => {
  const flows = useSelector((state: RootState) => state.flow.flows)

  const renderHeader = () =>  {
    return <Header><Button onClick={() => props.onSelect(undefined)}>+</Button></Header>
  }

  return (
    <Container>
      <MenuList
        size='small'
        header={renderHeader()}
        onSelect={props.onSelect}
        dataSource={flows}
        renderItem={(item: Flow) => (
          <MenuItem isSelected={item.id === props.selectedFlowId} onSelect={() => props.onSelect(item)}> 
            <Item title={item.name}/>
          </MenuItem> 
        )}
      />
    </Container>
  );
};

export default FlowList;
